module.exports = __webpack_public_path__ + "static/media/icon-all-categories.71ea42d6.svg";